import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import useSWR from 'swr';
import { localAxios } from '../api';
import VisitorContext from '../pages/register-visitor/VisitorContext';

const ScreenHeader = ({ message }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [accountOpen, setAccountOpen] = useState(false);
    const navigate = useNavigate();
    const { data, mutate } = useSWR('/api/me', localAxios);
    const { clearAll } = useContext(VisitorContext);

    const isLoggedIn = !!data?.data?.loggedIn;
    const accessiblePages = data?.data?.accessible_pages ?? [];

    useEffect(() => {
        if (data?.data?.loggedIn) {
            localStorage.setItem('userProfile', JSON.stringify({
                email:        data.data.email        ?? '',
                first_name:   data.data.first_name   ?? '',
                last_name:    data.data.last_name     ?? '',
                organization: data.data.organization ?? '',
            }));
        }
    }, [data]);
    const firstName  = data?.data?.first_name ?? '';
    const lastName   = data?.data?.last_name  ?? '';
    const initials   = ((firstName[0] ?? '') + (lastName[0] ?? '')) || '?';

    const openMenu    = () => { setAccountOpen(false); setMenuOpen(o => !o); };
    const openAccount = () => { setMenuOpen(false); setAccountOpen(o => !o); };

    const navTo        = (path) => { setMenuOpen(false);    navigate(path); };
    const accountNavTo = (path) => { setAccountOpen(false); navigate(path); };

    const handleLogOut = async () => {
        setAccountOpen(false);
        try {
            await localAxios.post('/api/logout');
        } catch {}
        new Cookies().remove('token', { path: '/' });
        await mutate(null, { revalidate: false });
        clearAll();
        localStorage.clear();
        navigate('/login');
    };

    return (
        <div className="app-wide__header">
            <button type="button" className="hamburger-btn" onClick={openMenu} aria-label="Navigation menu">
                ☰
            </button>

            <span>{message}</span>

            {isLoggedIn && (
                <button type="button" className="account-btn" onClick={openAccount} aria-label="Account menu">
                    {initials}
                </button>
            )}

            {menuOpen && <>
                <div className="nav-overlay" onClick={() => setMenuOpen(false)} />
                <nav className="nav-drawer">
                    <button type="button" className="nav-item" onClick={() => navTo(isLoggedIn ? '/' : '/login')}>Home</button>
                    {isLoggedIn && <>
                        <button type="button" className="nav-item" onClick={() => navTo('/choose')}>Visit Now</button>
                        <button type="button" className="nav-item" onClick={() => navTo('/register-visitor')}>Plan a Site Visit</button>
                        {accessiblePages.includes('reports') &&
                            <button type="button" className="nav-item" onClick={() => navTo('/reports')}>Reports</button>}
                        {accessiblePages.includes('admin') &&
                            <button type="button" className="nav-item" onClick={() => navTo('/admin')}>Administration</button>}
                    </>}
                    <button type="button" className="nav-item" onClick={() => navTo('/help')}>Help</button>
                </nav>
            </>}

            {accountOpen && <>
                <div className="nav-overlay" onClick={() => setAccountOpen(false)} />
                <nav className="account-drawer">
                    <button type="button" className="nav-item" onClick={() => accountNavTo('/account')}>Account</button>
                    <button type="button" className="nav-item" onClick={handleLogOut}>Log Out</button>
                </nav>
            </>}
        </div>
    );
};

export default ScreenHeader;
